import script from "./competenzeAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./competenzeAwards.vue?vue&type=script&setup=true&lang=js"

import "./competenzeAwards.vue?vue&type=style&index=0&id=4c9e339a&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9e339a"]])

export default __exports__